import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import TransactionListComp from "./TransactionListComp";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { ref, onValue } from "firebase/database";
import { database } from "../../firebase/firebase";
// import { database } from "../firebase/firebase";
const TransactionList = () => {
  const { pathname } = useLocation();
  let count = sessionStorage.getItem("notification");
  let notification = JSON.parse(count);
  const path = pathname?.replace("/", "");
  const [isCount, setIsCount] = useState({});
  const { paginationData, setpaginationData } = useGlobalContext();
  const [subTabs, setsubTabs] = useState(paginationData?.[path] ?? "Upcoming");
  const buttons = [
    "Upcoming",
    "CheckIn",
    "Completed",
    "Hold",
    "Cancelled",
    "Refund",
  ];
  const [optionsList, setOptionsList] = useState({
    category: [],
    serviceType: [],
  });

  useEffect(() => {
    setpaginationData((prev) => ({ ...prev, [path]: subTabs }));
  }, [subTabs]);
  useEffect(() => {
    getServices();
    getcategoriesList();
  }, []);

  const getServices = async () => {
    let res = await get(`${URLS.SERVICESLIST}list`);
    console.log("resres", res);
    let formatted = res?.data?.map((item) => ({
      label: item.display_name,
      value: item.id,
    }));
    setOptionsList((prev) => ({ ...prev, serviceType: formatted }));
  };

  const getcategoriesList = async (id) => {
    const res = await get(URLS.HOTELCATEGORIES_DROPDOWN);
    console.log("categories List", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.display_name };
      });
      setOptionsList((prev) => ({ ...prev, category: modifiedList }));
    }
  };
  useEffect(() => {
    // const dbRef = ref(database, `notifications_count/${isActiveViewNotification}`);
    const dbRef = ref(database, `notifications_count/transactions`);
    const unsubscribe = onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      console.log("Realtime Data:", data);
      setIsCount(data);
      // sessionStorage.setItem("notification", JSON.stringify(data));
    });

    return () => unsubscribe();
  }, []);

  // useEffect(() => {

  //   setIsCount((pre) => {
  //   ...pre
  //   {
  //     upcoming: notification?.transactions?.upcoming
  //     cancelled: notification?.transactions?.upcoming

  //   }
  //   });
  // });

  console.log(
    "AsjdhaksdhjkIsCount",
    isCount,
    subTabs,
    isCount?.subTabs?.cancelled,
  );

  return (
    <div>
      <Topbar header={"Transaction"} />
      <div className="d-flex ac-js gap-4">
        {buttons.map((item, ind) => {
          return (
            <p
              key={ind}
              onClick={() => {
                setsubTabs(item);
              }}
              className={`${
                subTabs === item ? "prim-btn" : "sec"
              } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 pointer ${
                ind != 0 && "ms-4"
              }`}
            >
              {item}{" "}
              {item == "Hold"
                ? isCount?.hold !== 0 && isCount?.hold
                  ? `-${isCount?.hold}`
                  : ""
                : item == "Cancelled"
                  ? isCount?.cancelled !== 0 && isCount?.cancelled
                    ? `-${isCount?.cancelled}`
                    : ""
                  : ""}
            </p>
          );
        })}
      </div>
      {/* <p>Count</p>
      <p>
        {subTabs} :{isCount?.subTabs}{" "}
      </p> */}
      <TransactionListComp
        key={subTabs}
        optionsList={optionsList}
        type={subTabs}
      />
    </div>
  );
};

export default TransactionList;
